<template>
  <div class="share-stats-page">
    <!-- 顶部统计卡片 -->
    <div class="stats-cards">
      <div class="stat-card">
        <div class="stat-value">{{ stats.totalShares || 0 }}</div>
        <div class="stat-label">{{ $t('customer.ShareStats.line7_text') }}</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ stats.totalViews || 0 }}</div>
        <div class="stat-label">{{ $t('customer.ShareStats.line11_text') }}</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ stats.totalRegisters || 0 }}</div>
        <div class="stat-label">{{ $t('customer.ShareStats.line15_text') }}</div>
      </div>
      <div class="stat-card highlight">
        <div class="stat-value">{{ stats.pendingRewards || 0 }}</div>
        <div class="stat-label">{{ $t('customer.ShareStats.line19_text') }}</div>
      </div>
    </div>

    <!-- Tab 切换 -->
    <el-tabs v-model="activeTab" class="share-tabs">
      <!-- 分享记录 -->
      <el-tab-pane label="分享记录" name="records">
        <div class="records-list" v-loading="recordsLoading">
          <div
            v-for="record in records"
            :key="record.id"
            class="record-card"
          >
            <div class="record-header">
              <img :src="getImageUrl(record.productImage)" class="record-thumb" v-if="record.productImage" />
              <div class="record-info">
                <div class="record-name">{{ record.productName || '商品' }}</div>
                <div class="record-time">{{ formatTime(record.createdAt) }}</div>
              </div>
              <span class="record-status" :class="record.status">{{ record.status === 'ACTIVE' ? '有效' : '已过期' }}</span>
            </div>
            <div class="record-stats">
              <span>👁 {{ record.viewCount || 0 }} 浏览</span>
              <span>👤 {{ record.registerCount || 0 }} 注册</span>
              <span>📦 {{ record.firstOrderCount || 0 }} 首单</span>
            </div>
            <div class="record-actions">
              <el-button size="mini" type="primary" icon="el-icon-share" @click="copyShareUrl(record.shareUrl)">
                复制链接
              </el-button>
              <el-button size="mini" type="success" icon="el-icon-chat-dot-round" @click="shareViaWhatsApp(record)">
                WhatsApp
              </el-button>
            </div>
          </div>
          <el-empty v-if="!recordsLoading && records.length === 0" description="暂无分享记录" />
          <div class="load-more" v-if="hasMore && !recordsLoading">
            <el-button @click="loadMoreRecords" size="small">{{ $t('customer.ShareStats.line57_text') }}</el-button>
          </div>
        </div>
      </el-tab-pane>

      <!-- 奖励记录 -->
      <el-tab-pane label="奖励记录" name="rewards">
        <div class="rewards-list" v-loading="rewardsLoading">
          <div
            v-for="reward in rewards"
            :key="reward.id"
            class="reward-card"
          >
            <div class="reward-header">
              <div class="reward-user">
                <span class="user-label">{{ $t('customer.ShareStats.line72_text') }}</span>
                <span class="user-name">{{ reward.registrantUsername || '新用户' }}</span>
              </div>
              <span class="reward-status-badge" :class="reward.rewardStatus.toLowerCase()">
                {{ getRewardStatusText(reward.rewardStatus) }}
              </span>
            </div>
            <div class="reward-detail">
              <span class="label">{{ $t('customer.ShareStats.line80_text') }}</span>
              <span class="value">{{ reward.rewardProductName || '—' }}</span>
            </div>
            <div class="reward-detail">
              <div class="reward-amount">
                <span class="label">{{ $t('customer.ShareStats.line85_text') }}</span>
                <span class="value">¥{{ reward.rewardValue || 0 }}</span>
              </div>
              <div class="reward-time">{{ formatTime(reward.createdAt) }}</div>
            </div>
            <div class="reward-detail" v-if="reward.reviewNote">
              <span class="label">{{ $t('customer.ShareStats.line91_text') }}</span>
              <span class="note">{{ reward.reviewNote }}</span>
            </div>
            <div class="reward-detail" v-if="reward.distributionMethod">
              <span class="label">{{ $t('customer.ShareStats.line95_text') }}</span>
              <span class="value">{{ getDistributionText(reward.distributionMethod) }}</span>
            </div>
          </div>
          <el-empty v-if="!rewardsLoading && rewards.length === 0" description="暂无奖励记录" />
          <div class="load-more" v-if="hasMoreRewards && !rewardsLoading">
            <el-button @click="loadMoreRewards" size="small">{{ $t('customer.ShareStats.line101_text') }}</el-button>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import shareApi from '@/services/share';
import { getImageUrl } from '@/utils/image';

export default {
  name: 'ShareStats',
  data() {
    return {
      activeTab: 'records',
      stallId: null,
      stats: {},
      records: [],
      rewards: [],
      recordsLoading: false,
      rewardsLoading: false,
      recordsPage: 0,
      rewardsPage: 0,
      pageSize: 20,
      hasMore: true,
      hasMoreRewards: true
    };
  },
  created() {
    this.stallId = this.getStallId();
    this.loadStats();
    this.loadRecords();
    this.loadRewards();
  },
  methods: {
    async loadStats() {
      console.log('ShareStats.loadStats: stallId =', this.stallId);
      if (!this.stallId) {
        console.warn('ShareStats: stallId is null, skipping loadStats');
        return;
      }
      try {
        this.stats = await shareApi.getMyStats(this.stallId);
        console.log('ShareStats.loadStats success:', this.stats);
      } catch (error) {
        console.error('加载统计失败:', error);
      }
    },

    async loadRecords() {
      if (!this.stallId) {
        console.warn('ShareStats: stallId is null, skipping loadRecords');
        return;
      }
      this.recordsLoading = true;
      console.log('ShareStats.loadRecords: stallId =', this.stallId, 'page =', this.recordsPage);
      try {
        const result = await shareApi.getMyRecords(this.stallId, this.recordsPage, this.pageSize);
        console.log('ShareStats.loadRecords result:', result);
        const content = result.content || result.items || [];
        this.records = this.recordsPage === 0 ? content : [...this.records, ...content];
        this.hasMore = content.length === this.pageSize;
      } catch (error) {
        console.error('加载分享记录失败:', error);
      } finally {
        this.recordsLoading = false;
      }
    },

    async loadRewards() {
      if (!this.stallId) return;
      this.rewardsLoading = true;
      try {
        const result = await shareApi.getMyRewards(this.stallId, this.rewardsPage, this.pageSize);
        const content = result.content || result.items || [];
        this.rewards = this.rewardsPage === 0 ? content : [...this.rewards, ...content];
        this.hasMoreRewards = content.length === this.pageSize;
      } catch (error) {
        console.error('加载奖励记录失败:', error);
      } finally {
        this.rewardsLoading = false;
      }
    },

    loadMoreRecords() {
      this.recordsPage++;
      this.loadRecords();
    },

    loadMoreRewards() {
      this.rewardsPage++;
      this.loadRewards();
    },

    copyShareUrl(url) {
      this.copyToClipboard(url);
      this.$message.success('链接已复制');
    },

    shareViaWhatsApp(record) {
      const text = encodeURIComponent(`${record.productName || '商品'} 特价 ¥${record.priceAtShare}！点击购买 👉 ${record.shareUrl}`);
      window.open(`https://api.whatsapp.com/send?text=${text}`, '_blank');
    },

    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text);
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
    },

    formatTime(time) {
      if (!time) return '';
      const date = new Date(time);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
    },

    getRewardStatusText(status) {
      const map = {
        PENDING: '待审核',
        APPROVED: '已通过',
        REJECTED: '已拒绝',
        DISTRIBUTED: '已发放'
      };
      return map[status] || status;
    },

    getDistributionText(method) {
      const map = {
        DELIVERY: '配送',
        PICKUP: '自提',
        COUPON_CODE: '优惠券码'
      };
      return map[method] || method;
    },

    getStallId() {
      // 优先从路由参数取，其次从 localStorage 取
      if (this.$route.query.stallId) {
        console.log('ShareStats: stallId from route =', this.$route.query.stallId);
        return Number(this.$route.query.stallId);
      }
      // 登录页存的是 stored_customer_id
      const storedId = localStorage.getItem('stored_customer_id');
      console.log('ShareStats: stored_customer_id =', storedId);
      if (storedId) {
        console.log('ShareStats: stallId from localStorage =', Number(storedId));
        return Number(storedId);
      }
      // 也兼容从身份选择页取的 customerId
      const sessId = sessionStorage.getItem('customer_id');
      console.log('ShareStats: customer_id(session) =', sessId);
      return Number(sessId);
    }
  }
};
</script>

<style scoped>
.share-stats-page {
  padding: 16px;
  background: #f5f5f5;
  min-height: 100vh;
}

.stats-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-bottom: 16px;
}

.stat-card {
  background: white;
  border-radius: 10px;
  padding: 14px 10px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.stat-card.highlight {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
  color: white;
}

.stat-card.highlight .stat-label {
  color: rgba(255,255,255,0.9);
}

.stat-value {
  font-size: 22px;
  font-weight: bold;
  color: #333;
}

.stat-label {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}

.share-tabs {
  background: white;
  border-radius: 10px;
  padding: 10px;
}

.records-list,
.rewards-list {
  padding: 10px 0;
}

.record-card {
  background: #f8f8f8;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
}

.record-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.record-thumb {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  object-fit: cover;
}

.record-info {
  flex: 1;
  min-width: 0;
}

.record-name {
  font-size: 14px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.record-time {
  font-size: 12px;
  color: #999;
}

.record-status {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
}

.record-status.ACTIVE {
  background: #e8f5e9;
  color: #4caf50;
}

.record-status.EXPIRED {
  background: #f5f5f5;
  color: #999;
}

.record-stats {
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: #666;
  margin-bottom: 8px;
}

.record-actions {
  display: flex;
  gap: 8px;
}

.reward-card {
  background: #f8f8f8;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
}

.reward-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.reward-user {
  display: flex;
  align-items: center;
  gap: 6px;
}

.user-label {
  font-size: 12px;
  color: #999;
}

.user-name {
  font-size: 14px;
  font-weight: 500;
}

.reward-status-badge {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
}

.reward-status-badge.pending {
  background: #fff3e0;
  color: #ff9800;
}

.reward-status-badge.approved {
  background: #e8f5e9;
  color: #4caf50;
}

.reward-status-badge.rejected {
  background: #ffebee;
  color: #f44336;
}

.reward-status-badge.distributed {
  background: #e3f2fd;
  color: #2196f3;
}

.reward-detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  margin-bottom: 4px;
}

.reward-detail .label {
  color: #999;
}

.reward-detail .value {
  font-weight: 500;
}

.reward-detail .note {
  color: #666;
  flex: 1;
  margin-left: 8px;
  text-align: right;
}

.reward-amount .value {
  color: #e74c3c;
  font-size: 16px;
  font-weight: bold;
}

.load-more {
  text-align: center;
  padding: 12px 0;
}

@media (max-width: 480px) {
  .stats-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
